import { createReducer } from '@reduxjs/toolkit';
import { elevioActions } from '../elevio.actions';
export const initialFeedbackState = {
    stage: 'initial',
    email: '',
    feedback: '',
};
export const feedbackReducer = createReducer(initialFeedbackState, (builder) => {
    builder
        .addCase(elevioActions.feedback.ticketAssisted, (state) => {
        state.stage = 'helpfulSubmitting';
    })
        .addCase(elevioActions.feedback.haveFeedbackPressed, (state, action) => {
        state.stage = action.payload.isPositive ? 'helpfulSubmitting' : 'form';
        state.email = action.payload.email;
    })
        .addCase(elevioActions.feedback.feedbackSubmit, (state) => {
        state.stage = 'formSubmitting';
    })
        .addCase(elevioActions.feedback.feedbackReset, (state) => {
        state.email = initialFeedbackState.email;
        state.feedback = initialFeedbackState.feedback;
        state.stage = initialFeedbackState.stage;
    })
        .addCase(elevioActions.feedback.feedbackChanged, (state, action) => {
        state.feedback = action.payload.feedback;
    });
});
